import * as flights from '../../flights';

export class PriceFilter {
    min: number;
    max: number;
    rangeMin: number;
    rangeMax: number;
    currencyCode?: string;

    constructor(flights: flights.FlightModel[]) {
        let minVal = 0;
        let maxVal = 0;
        let currencyCode = '';

        flights.forEach(f => {
            if (!minVal || minVal > f.billingPrice) {
                minVal = f.billingPrice;
            }

            if (!maxVal || maxVal < f.billingPrice) {
                maxVal = f.billingPrice;
            }
            if (f.currencyCode) {
                currencyCode = f.currencyCode;
            }
        });

        if (minVal > 0
            && maxVal > 0
            && minVal !== maxVal) {
            this.min = minVal;
            this.max = maxVal;
        } else {
            this.min = 0;
            this.max = 0;
        }

        this.rangeMin = this.min;
        this.rangeMax = this.max;
        this.currencyCode = currencyCode;
    }

    get touched(): boolean {
        return this.rangeMin !== this.min || this.rangeMax !== this.max;
    }

    clear() {
        this.rangeMin = this.min;
        this.rangeMax = this.max;
    }

    check(flight: flights.FlightModel): boolean {
        if (this.min !== this.max && (this.min !== this.rangeMin || this.max !== this.rangeMax)) {
            if (flight.billingPrice < this.rangeMin) {
                return false;
            }

            if (flight.billingPrice > this.rangeMax) {
                return false;
            }
        }

        return true;
    }
}
